<label>Reboot media player daily at:</label>
<popup-time-picker id="rebootTime" ngDefaultControl [(ngModel)]="model.restartTime"></popup-time-picker>